import { Platform } from "@-/com.npmjs.react-native";

/**
 * The standard height of the opaque control row an `(app)` tab paints directly below the status
 * bar. Tabs should render `PrimaryControlsStripToolbar` rather than reaching for this constant: publishing
 * the height to the registry is what keeps the shared header fade aligned.
 */
// Native: 36px controls + 4px clearance, matching the bottom tabs content inset.
export const PRIMARY_CONTROLS_STRIP_TOOLBAR_HEIGHT = Platform.OS === "web" ? 48 : 40;
